import React from 'react';
import { Result, Button, Descriptions } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';

const BookingConfirmation = ({ slot, onClose }) => {
  const formatDate = (dateStr) => {
    return new Date(dateStr).toLocaleDateString('fr-FR', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });
  };

  return (
    <div style={{ padding: '40px 20px', textAlign: 'center' }}>
      <Result
        icon={<CheckCircleOutlined style={{ color: '#059669' }} />}
        title="Rendez-vous confirmé !"
        subTitle="Le rendez-vous a été enregistré avec succès."
        extra={[
          <Button type="primary" key="close" onClick={onClose} size="large"
            style={{ background: '#059669', borderColor: '#059669' }}>
            Fermer
          </Button>,
        ]}
      >
        {slot && (
          <Descriptions column={1} bordered size="small" style={{ maxWidth: 350, margin: '0 auto' }}>
            <Descriptions.Item label="Date">{formatDate(slot.date)}</Descriptions.Item>
            <Descriptions.Item label="Heure">{slot.heure}</Descriptions.Item>
            <Descriptions.Item label="Équipe">{slot.equipe_nom}</Descriptions.Item>
          </Descriptions>
        )}
      </Result>
    </div>
  );
};

export default BookingConfirmation;
